"use strict";

Shopify.theme.jsStrainCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsStrainCollection = $.extend(this, Shopify.theme.getSectionData($section));
	const $sliderEl = $section.find('.is-width-wide [data-slider]')
    this.createSlider($sliderEl);

    const $sliderElStandard = $section.find('.is-width-standard [data-slider]')
    this.createSliderStandard($sliderElStandard);
  }, 
  createSlider: function createSlider($sliderEl) {

    const slider = $sliderEl.flickity({
      lazyLoad: 2,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: true,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            slider.flickity('resize');
          }, 500);
        }
      }
    });
  },
  createSliderStandard: function createSliderStandard($sliderElStandard) {

    const sliderStandard = $sliderElStandard.flickity({
      lazyLoad: 2,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: false,
      pageDots: false,
      contain: true,
      prevNextButtons: true,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            sliderStandard.flickity('resize');
          }, 500);
        }
      }
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};